import type { ApolloClient, MutationUpdaterFn } from '@apollo/client';
import type { Language } from '@seek/ca-myprofile-utils';

import type * as Schema from 'src/types/graphql';

import { getAvailabilityOptionsFromCache } from './data';

export const updateCacheUpdateAvailability: MutationUpdaterFn<
  Schema.UpdateAvailabilityMutation
> = (cache, { data }) => {
  const _id = data?.updateAvailability?.viewer?._id || '';
  const availability = data?.updateAvailability?.viewer?.availability || null;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      availability: () => availability,
    },
  });
};

export const generateUpdateAvailabilityOptimisticResponse =
  ({ _id, apolloClient }: { _id: string; apolloClient: ApolloClient<any> }) =>
  ({
    availability: { id },
    languageCode,
  }: Schema.UpdateAvailabilityMutationVariables) => {
    const availabilityOptions = getAvailabilityOptionsFromCache(
      apolloClient.cache,
      languageCode as Language,
    );

    const description =
      availabilityOptions.find((option) => option.id === id)?.description || '';

    return {
      __typename: 'Mutation',
      updateAvailability: {
        ref: _id,
        __typename: 'UpdateAvailabilityPayload',
        viewer: {
          _id,
          __typename: 'Candidate',
          availability: {
            __typename: 'Availability',
            id,
            description,
          },
        },
      },
    };
  };
